

















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {StockInTargetType} from "@/enums/type";
import EmployeeSelector from "../../../shared/components/EmployeeSelector/index.vue";
import PartnerSelector from "../../../shared/components/PartnerSelector/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {stockInFastMulti} from "@/modules/warehouses/services";
import cloneDeep from 'lodash/cloneDeep';
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import {searchBillLading} from "@/modules/searchbilllading/service";
import StockInFastSuggestTable from "@/modules/warehouses/StockInFast/components/StockInFastSuggestTable.vue";

const form = {
    ladingCodes: [] as any,
    targetType: StockInTargetType.Employee,
    targetRowGuid: undefined,
    customerRowGuid: undefined
}

@Component({
    name: 'StockInFastMulti',
    components: {StockInFastSuggestTable, AInputBarCode, CustomerSelector, PartnerSelector, EmployeeSelector}
})
export default class extends mixins(CommonMixin) {
    form = cloneDeep(form);
    dataSource = [] as any;
    ladingCode = "";
    isSubmit = false;
    StockInTargetType = StockInTargetType;

    onchangeTargetType() {
        if (this.form.targetRowGuid)
            this.form.targetRowGuid = undefined;
    }

    async enterLadingCode(evt: any) {
        const ladingCode = evt?.target?.value as any;
        if (this.dataSource.some((data: any) => data.ladingCode === ladingCode)) {
            this.$message.error("Mã vận đơn đã có trong bảng");
            return;
        }
        try {
            const { data } = await searchBillLading(ladingCode);
            const lading = data.data;
            if (lading) {
                this.$message.error("Mã vận đơn đã tồn tại trong hệ thống");
                return;
            }
        } catch (e) {
        }
        const dataLading = {
            stt: this.dataSource.length + 1,
            ladingCode
        }
        this.dataSource.push(dataLading);
        this.form.ladingCodes.push(ladingCode);
        this.ladingCode = "";
    }

    acceptLadingCodes() {
        this.dataSource = this.dataSource
            .filter((data: any) => this.form.ladingCodes.includes(data.ladingCode))
            .map((data: any, index: number) => {
                data.stt = index + 1;
                return data;
            });
    }

    async submit() {
        if (!this.isValidForm()) return;
        try {
            this.isSubmit = true;
            await stockInFastMulti(this.form);
            this.form = cloneDeep(form);
            this.dataSource = [] as any;
            this.$message.success("Nhập kho nhanh thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Nhập kho nhanh thất bại");
        } finally {
            this.isSubmit = false;
        }
    }

    isValidForm() {
        if (!this.form.customerRowGuid) {
            this.$message.error("Chọn khách hàng");
            return false;
        }
        if (!this.form.targetRowGuid) {
            this.$message.error("Chọn nhân viên/đối tác bàn giao");
            return false;
        }
        if (!this.form.ladingCodes || !this.form.ladingCodes.length) {
            this.$message.error("Chưa có vận đơn nào");
            return false;
        }
        return true;
    }
}
